import { RouteComponentProps, Router, useLocation } from '@gatsbyjs/reach-router';
import { APCenter, APColumn, APImage, APSizedBox, APTag, APText, getIt, showErrorDialog } from 'ap-components';
import { useEffect } from 'react';
import MutualFundApiServices from '../../Services/MutualFundServices';
import { launchUrl } from '../DigilockerKYC/common';
import { CircularProgress } from '@mui/material';

export function SuccessPage(props: RouteComponentProps) {
    return (
        <APColumn mainAxisSize='max' crossAxisAlignment='stretch' style={{ width: "100vw" }} mainAxisAlignment="center">
            <APColumn>
                <APImage src="/icons/greenCheck.svg" height="80px" width="80px" />
                <APSizedBox height="32px" />
                <APText>
                    Your KYC Application is submitted successfully.
                </APText>
                <APSizedBox height="6px" />
                <APText>
                    You can now close this page.
                </APText>
            </APColumn>
        </APColumn>
    )
}

export function FailurePage(props: RouteComponentProps) {
    return (
        <APColumn mainAxisSize='max' crossAxisAlignment='stretch' style={{ width: "100vw" }} mainAxisAlignment="center">
            <APColumn>
                <APSizedBox height="32px" />
                <APText>
                    Your KYC Application submission failed.
                </APText>
                <APSizedBox height="6px" />
                <APText>
                    You can now close this page.
                </APText>
            </APColumn>
        </APColumn>
    )
}



export default function MasterKYCPage(props: RouteComponentProps) {
    {/* <SuccessResponse path='/success'></SuccessResponse> */ }
    return <Router style={{ display: "flex", height: "100%", width: "100%" }}>
        <MasterKYCStartPage path="/" default />
        <SuccessPage path="/success" />
        <FailurePage path="/failed" />
    </Router>
}
export function MasterKYCStartPage(props: RouteComponentProps) {

    const location = useLocation();

    let searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const source = searchParams.get("source");

    useEffect(() => {
        refetch();
    }, []);

    if (!token) {
        return <APCenter><APTag variant='negative'>Invalid user</APTag></APCenter>
    }

    async function refetch() {
        try {
            let redirUrl = await getIt(MutualFundApiServices).masterKyc({ token: token!, source: source ?? undefined });
            // window.open(redirUrl, "_blank");
            launchUrl(redirUrl);
        } catch (err: any) {
            showErrorDialog(err.message)
        }
    }

    return <APColumn mainAxisSize='max' mainAxisAlignment='center'>
        <APCenter>
            <CircularProgress size={60} />
        </APCenter>
    </APColumn>
}
